import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceUnitEnum } from '@qaroni-app/absences/types/absence-unit.enum';

@Component({
  selector: 'qaroni-absences-units-preview',
  templateUrl: './absences-units-preview.component.html',
  styleUrl: './absences-units-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsencesUnitsPreviewComponent {
  readonly time = input<number>(0);
  readonly unit = input<AbsenceUnitEnum | null>(null);
  readonly minutesToHours = input<boolean>(false);

  readonly daysPluralMapping = {
    '=1': $localize`día`,
    other: $localize`días`,
  };

  readonly weekPluralMapping = {
    '=1': $localize`semana`,
    other: $localize`semanas`,
  };

  get isHours(): boolean {
    return this.unit() === AbsenceUnitEnum.HOURS;
  }

  get isDays(): boolean {
    return this.unit() === AbsenceUnitEnum.DAYS;
  }
}
